export default {
  props: {
    customAttr: {
      type: Function,
      default: () => ''
    },
    options: {
      type: Array
    }
  }
}
